/**
 * Puts a room's code or link on the clipboard, for the lobby's Copy and
 * Share (the shell's `LobbyCode` only reports the presses; the copying is the
 * game's).
 *
 * Attempted twice: the async Clipboard API, then `document.execCommand('copy')`
 * over a temporary selection. The second is deprecated and kept, because the
 * first exists only in a secure context and a staging deployment may be plain
 * http. Resolves to whether either worked; never throws.
 */
export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    // No Clipboard API, or permission refused.
    return copyBySelection(text);
  }
}

/** The deprecated path, kept because plain http has no Clipboard API. */
function copyBySelection(text: string): boolean {
  const field = document.createElement('textarea');
  field.value = text;
  field.setAttribute('readonly', '');
  field.style.position = 'fixed';
  field.style.opacity = '0';
  document.body.appendChild(field);
  try {
    field.select();
    return document.execCommand('copy');
  } catch {
    return false;
  } finally {
    field.remove();
  }
}
